import React, { useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { ACTIVITIES } from './constants';
import Skeleton from '@mui/material/Skeleton';
const Legend = () => {
  const fakeValue = 25; // out of 100
  const duration = '0h:23m:05s';

  const [loading, SetLoading] = useState(true);

  setTimeout(() => {
    SetLoading(false)
  }, 2000);
  return (

    <Box>
      {
        loading ? (<div
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} >
            {
              [...Array(4)].map((_,) => (
                <Box
                  sx={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', justifyContent: { sm: 'center', xs: 'center' }, textAlign: { sm: 'center', xs: 'center' } }}
                >
                  <Box>
                    <Skeleton
                      variant="rectangular"
                      animation="wave"
                      sx={{
                        width: '65px',
                        height: '65px',
                        borderRadius: '100%',
                        marginBottom: '7px',
                      }}
                    />
                  </Box>
                  <Box sx={{ width: '80px' }}>
                    <Skeleton variant="text" sx={{ fontSize: '9px', marginBottom: '5px' }} />
                    <Skeleton variant="text" sx={{ fontSize: '9px' }} />
                  </Box>
                </Box>
              ))
            }

          </Box>

        </div>) : (<Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 4 }}>
          {Object.entries(ACTIVITIES).map(([key, { label, color }]) => (
            <Box key={key} sx={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', justifyContent: { sm: 'center', xs: 'center' }, textAlign: { sm: 'center', xs: 'center' } }}>
              <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <CircularProgress
                  variant="determinate"
                  value={100}
                  sx={{ color: '#eee' }}
                  size={64}
                  thickness={5}
                />
                <CircularProgress
                  variant="determinate"
                  value={fakeValue}
                  sx={{
                    color,
                    position: 'absolute',
                    left: 0,
                  }}
                  size={64}
                  thickness={5}
                />
              </Box>
              <Box>
                <Typography variant="body2" fontWeight="bold" >
                  {label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {duration}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>)
      }
    </Box>
  );
};

export default Legend;
